module.exports = fox._r("flash/flowplayer.pseudostreaming-3.2.11.swf", __webpack_public_path__ + "_/_/_/root/flash/flowplayer.pseudostreaming-3.2.11.swf");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/flash/flowplayer.pseudostreaming-3.2.11.swf
// module id = 672
// module chunks = 4